(function(root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.BadgeBuzzProductOptionCatalog = api;
})(typeof window !== 'undefined' ? window : globalThis, function() {
  'use strict';

  function option(value, label, extra) {
    return Object.assign({ value: value, label: label || value }, extra || {});
  }

  var nameBadgeMaterials = {
    paper: {
      moq: 250,
      sidesAllowed: ['single', 'double'],
      printIntro: true,
      printing: [
        { v: 'yes-color', l: 'Yes, I want to print in color on-site' },
        { v: 'no-mono', l: "No, I don't want to print in color on-site" },
      ],
      size: [
        { v: '4x3', name: 'Small', dim: '4" × 3"', cm: '(10.16 × 7.62 cm)' },
        { v: '4x6', name: 'Large', dim: '4" × 6"', cm: '(10.16 × 15.24 cm)' },
      ],
      slots: [
        { v: 'none', name: 'None', note: 'Requires a badge holder' },
        { v: 'three', name: 'Three', disabled: true },
      ],
    },
    'tear-resistant': {
      moq: 250,
      sidesAllowed: ['single', 'double'],
      printIntro: true,
      printing: [
        { v: 'yes-color', l: 'Yes, I want to print in color on-site' },
        { v: 'no-mono', l: "No, I don't want to print in color on-site" },
      ],
      size: [
        { v: '4x3', name: 'Small', dim: '4" × 3"', cm: '(10.16 × 7.62 cm)' },
        { v: '4x5', name: 'Medium', dim: '4" × 5"', cm: '(10.16 × 12.70 cm)' },
        { v: '4x6', name: 'Large', dim: '4" × 6"', cm: '(10.16 × 15.24 cm)' },
      ],
      slots: [{ v: 'three', name: 'Three' }],
    },
    butterfly: {
      moq: 250,
      sidesAllowed: ['double'],
      printIntro: true,
      printing: [{ v: 'yes-color', l: 'Yes, I want to print in color on-site' }],
      size: [
        { v: '3.8x5.3', name: 'Large', dim: '3.8" × 5.3"', cm: '(9.65 × 13.46 cm)' },
        { v: '3.8x3.2', name: 'Small', dim: '3.8" × 3.2"', cm: '(9.65 × 8.13 cm)' },
      ],
      slots: [{ v: 'three', name: 'Three' }],
    },
    intellibadge: {
      moq: 400,
      sidesAllowed: ['double'],
      printIntro: false,
      printing: [],
      size: [
        { v: '4x3', name: 'Small', dim: '4" × 3"', cm: '(10.16 × 7.62 cm)' },
        { v: '4x6', name: 'Large', dim: '4" × 6"', cm: '(10.16 × 15.24 cm)' },
      ],
      slots: [{ v: 'three', name: 'Three' }],
    },
    plastic: {
      moq: 200,
      sidesAllowed: ['double'],
      printIntro: true,
      printing: [
        { v: 'yes-color', l: 'Yes, I want to print in color on-site' },
        { v: 'no-mono', l: "No, I don't want to print in color on-site" },
      ],
      size: [
        { v: '3.74x5.31', name: 'Medium Square', dim: '3.74" × 5.31"', cm: '(9.50 × 13.49 cm)' },
        { v: '4.33x6.3', name: 'Large Square', dim: '4.33" × 6.3"', cm: '(11.0 × 16.0 cm)' },
      ],
      slots: [
        { v: 'one', name: 'One' },
        { v: 'two', name: 'Two' },
      ],
    },
  };

  function nameBadgeGroups(material) {
    var data = nameBadgeMaterials[material];
    var groups = [
      { label: 'On-Site Printing', options: data.printing.map(function(item) { return option(item.v, item.l); }) },
      { label: 'Size', options: data.size.map(function(item) { return option(item.v, item.name, { meta: [item.dim, item.cm].filter(Boolean).join(' ') }); }) },
      { label: 'Single or Double-Sided', options: data.sidesAllowed.map(function(value) { return option(value, value === 'single' ? 'Single Sided' : 'Double-Sided'); }) },
      { label: 'Perforated Slots', options: data.slots.map(function(item) { return option(item.v, item.name, { meta: item.note || '' }); }) },
    ];
    if (material === 'plastic') {
      groups.push(
        { label: 'Finish', options: [option('Glossy'), option('Matte')] },
        { label: 'Clear pouch', options: [option('No'), option('Yes')] },
      );
    }
    return groups;
  }

  var lanyardAttachmentOptions = [
    option('Iron Polished silver bulldog clip', null, { supportedWidths: ['3/8"', '1/2"', '5/8"', '3/4"'] }),
    option('Iron Polished silver J-hook', null, { supportedWidths: ['3/8"', '1/2"', '5/8"', '3/4"', '1"'] }),
    option('Iron polished silver suspender bulldog clip', null, { supportedWidths: ['3/8"', '1/2"', '5/8"', '3/4"', '1"'] }),
    option('Plastic matte black hook', null, { supportedWidths: ['3/8"', '5/8"', '3/4"'] }),
    option('Plastic matte black swivel snap hook', null, { supportedWidths: ['1/2"', '5/8"', '3/4"'] }),
    option('Zinc Alloy Polished silver oval clasp', null, { supportedWidths: ['3/8"', '5/8"', '3/4"', '1"'] }),
    option('Zinc Alloy Polished silver swivel snap lobster hook', null, { supportedWidths: ['3/8"', '1/2"', '5/8"', '3/4"', '1"'] }),
  ];

  var lanyardFamilies = [
    {
      handle: 'bulldog-metal-clip-lanyards',
      label: 'Bulldog Metal Clip',
      styles: [
        option('Iron polished silver suspender bulldog clip', 'With Suspender'),
        option('Iron Polished silver bulldog clip', 'Without Suspender'),
      ],
    },
    {
      handle: 'metal-hook-lanyards',
      label: 'Metal Hook',
      styles: [
        option('Zinc Alloy Polished silver swivel snap lobster hook', 'Lobster Hook', {meta: 'Zinc Alloy'}),
        option('Iron Polished silver J-hook', 'J-Hook', {meta: 'Iron Polished'}),
        option('Zinc Alloy Polished silver oval clasp', 'Oval Clasp', {meta: 'Zinc Alloy'}),
      ],
    },
    {
      handle: 'plastic-hook-lanyards',
      label: 'Plastic Hook',
      styles: [
        option('Plastic matte black swivel snap hook', 'With Swivel'),
        option('Plastic matte black hook', 'Without Hook'),
      ],
    },
  ];

  function lanyardFamilyFor(handle) {
    return lanyardFamilies.find(function(family) { return family.handle === handle; }) || null;
  }

  function lanyardSupportedWidths(attachmentType) {
    var match = lanyardAttachmentOptions.find(function(item) { return item.value === attachmentType; });
    return match ? match.supportedWidths.slice() : [];
  }

  var lanyardGroups = [
    { label: 'Customization', options: [option('Customized'), option('Solid Color')] },
    {
      label: 'Color',
      options: [
        option('Black', 'Black', { hex: '#000000' }),
        option('Gray', 'Gray', { hex: '#6b7280' }),
        option('White', 'White', { hex: '#ffffff' }),
        option('Navy Blue', 'Navy Blue', { hex: '#1e3a8a' }),
        option('Magenta', 'Magenta', { hex: '#c026d3' }),
        option('Green', 'Green', { hex: '#16a34a' }),
        option('Yellow', 'Yellow', { hex: '#facc15' }),
        option('Orange', 'Orange', { hex: '#f97316' }),
        option('Red', 'Red', { hex: '#991b1b' }),
        option('Custom', 'Custom', { hex: '#ffffff' }),
      ],
    },
    {
      label: 'Print method',
      options: [
        option('Sublimation - full color, two sides', 'Full-color sublimation', { meta: 'Printed on both sides' }),
        option('Screen print - one color, one side', 'Screen print', { meta: 'One color, one side' }),
        option('Screen print - one color, two sides', 'Screen print', { meta: 'One color, two sides' }),
      ],
    },
    { label: 'Attachment / Clips', options: [option('Single Clip'), option('Double Clip')] },
    {
      label: 'Width',
      options: [
        option('3/8"', '3/8"', { meta: '1.0 cm' }),
        option('1/2"', '1/2"', { meta: '1.2 cm' }),
        option('5/8"', '5/8"', { meta: '1.5 cm' }),
        option('3/4"', '3/4"', { meta: '2.0 cm' }),
        option('1"', '1"', { meta: '2.5 cm' }),
      ],
    },
    {
      label: 'Attachment type',
      options: lanyardAttachmentOptions,
    },
  ];

  function lanyardGroupsForFamily(handle) {
    var family = lanyardFamilyFor(handle);
    if (!family) return lanyardGroups;
    var allowedStyles = new Set(family.styles.map(function(style) {
      return style.value;
    }));
    return lanyardGroups.map(function(group) {
      if (group.label !== 'Attachment type') return group;
      return Object.assign({}, group, {
        options: group.options.filter(function(item) {
          return allowedStyles.has(item.value);
        }),
      });
    });
  }

  // The legacy Shopify/Zakeke products only have variants through 3/4".
  // Keep them stable while the replacement attachment-led products use the
  // complete five-width supplier workbook.
  var legacyLanyardGroups = lanyardGroups.map(function(group) {
    if (group.label !== 'Width') return group;
    return Object.assign({}, group, {
      options: group.options.filter(function(item) { return item.value !== '1"'; }),
    });
  });

  var adhesiveGroups = [
    {
      label: 'Size',
      options: [
        option('4x3', 'Medium Rectangle', { meta: '4" × 3" (10.16 × 7.62 cm)' }),
        option('3x2', 'Small', { meta: '3" × 2" (7.62 × 5.08 cm)' }),
        option('4x4', 'Large', { meta: '4" × 4" (10.16 × 10.16 cm)' }),
        option('3x3', 'Medium Square', { meta: '3" × 3" (7.62 × 7.62 cm)' }),
      ],
    },
    { label: 'Color', options: [option('White'), option('Clear')] },
    { label: 'Design', options: [option('Blank')] },
  ];

  var nameBadgePricingGroups = [
    'On-Site Printing',
    'Size',
    'Single or Double-Sided',
    'Perforated Slots',
  ];
  var paperDesignGroup = {
    label: 'Design',
    options: [
      option('Pre-Printed on one side only'),
      option('Pre-printed on both sides'),
      option('Blank'),
    ],
  };
  var lanyardPricingGroups = [
    'Customization',
    'Color',
    'Print method',
    'Attachment / Clips',
    'Width',
    'Attachment type',
  ];
  var definitions = {
    'paper-name-badge': {
      packSize: 250,
      material: 'paper',
      groups: nameBadgeGroups('paper').concat([paperDesignGroup]),
      pricingGroups: nameBadgePricingGroups.concat(['Design']),
    },
    'tear-resistant-name-badge': {
      packSize: 250,
      material: 'tear-resistant',
      groups: nameBadgeGroups('tear-resistant').concat([paperDesignGroup]),
      pricingGroups: nameBadgePricingGroups.concat(['Design']),
    },
    'butterfly-name-badge': {
      packSize: 250,
      material: 'butterfly',
      artworkMode: 'none',
      forcedDesign: 'Blank',
      groups: nameBadgeGroups('butterfly'),
      pricingGroups: nameBadgePricingGroups,
    },
    'intellibadge-name-badge': {
      packSize: 400,
      material: 'intellibadge',
      groups: nameBadgeGroups('intellibadge').concat([paperDesignGroup]),
      pricingGroups: [
        'Size',
        'Single or Double-Sided',
        'Perforated Slots',
        'Design',
      ],
    },
    'plastic-name-badge': {
      packSize: 200,
      material: 'plastic',
      groups: nameBadgeGroups('plastic'),
      pricingGroups: [
        'Size',
        'Perforated Slots',
        'Finish',
        'Clear pouch',
      ],
    },
    'adhesive-name-badge': {
      packSize: 250,
      artworkMode: 'none',
      forcedDesign: 'Blank',
      groups: adhesiveGroups,
      pricingGroups: ['Size', 'Color', 'Design'],
    },
    'metal-clip-lanyard': {
      packSize: 50,
      standaloneCustomization: 'Solid Color',
      pricingDefaults: {'Lanyard add-on': 'No Add-On'},
      groups: legacyLanyardGroups,
      pricingGroups: lanyardPricingGroups,
    },
    'custom-lanyards': {
      packSize: 200,
      standaloneCustomization: 'Customized',
      pricingDefaults: {'Lanyard add-on': 'No Add-On'},
      groups: legacyLanyardGroups,
      pricingGroups: lanyardPricingGroups,
    },
    'bulldog-metal-clip-lanyards': {
      packSize: 200,
      defaultCustomization: 'Customized',
      solidColorPricing: true,
      lanyardFamily: 'bulldog-metal-clip-lanyards',
      pricingDefaults: {
        'Lanyard add-on': 'No Add-On',
      },
      groups: lanyardGroupsForFamily('bulldog-metal-clip-lanyards'),
      pricingGroups: lanyardPricingGroups,
    },
    'metal-hook-lanyards': {
      packSize: 200,
      defaultCustomization: 'Customized',
      solidColorPricing: false,
      lanyardFamily: 'metal-hook-lanyards',
      pricingDefaults: {
        'Lanyard add-on': 'No Add-On',
      },
      groups: lanyardGroupsForFamily('metal-hook-lanyards'),
      pricingGroups: lanyardPricingGroups,
    },
    'plastic-hook-lanyards': {
      packSize: 200,
      defaultCustomization: 'Customized',
      solidColorPricing: false,
      lanyardFamily: 'plastic-hook-lanyards',
      pricingDefaults: {
        'Lanyard add-on': 'No Add-On',
      },
      groups: lanyardGroupsForFamily('plastic-hook-lanyards'),
      pricingGroups: lanyardPricingGroups,
    },
    wristband: {
      packSize: 1,
      purchasable: false,
      groups: [],
      pricingGroups: [],
    },
  };

  function normalize(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function get(handle) {
    return definitions[handle] || null;
  }

  function groupsFor(handle, product) {
    var definition = get(handle);
    if (!definition) return [];
    var variantLabels = ((product && product.options) || []).map(function(item) {
      return normalize(typeof item === 'string' ? item : item && item.name);
    });
    return definition.groups.filter(function(group) {
      return variantLabels.indexOf(normalize(group.label)) === -1;
    });
  }

  function syncNodes(container, selector, options, update) {
    if (!container) return;
    var nodes = Array.prototype.slice.call(container.querySelectorAll(selector));
    while (nodes.length < options.length && nodes.length) {
      var clone = nodes[nodes.length - 1].cloneNode(true);
      container.appendChild(clone);
      nodes.push(clone);
    }
    nodes.forEach(function(node, index) {
      if (index >= options.length) {
        node.remove();
        return;
      }
      update(node, options[index], index);
    });
  }

  function setSelected(node, selected) {
    node.classList.toggle('selected', selected);
    node.classList.toggle('active', selected);
    node.setAttribute('aria-pressed', selected ? 'true' : 'false');
    node.setAttribute('aria-checked', selected ? 'true' : 'false');
  }

  function selectExclusive(group, chosen, selector) {
    selector = selector || '.bb-visual-radio-btn, .bb-optcard';
    if (
      !group ||
      !chosen ||
      typeof group.querySelectorAll !== 'function' ||
      !group.contains(chosen) ||
      typeof chosen.matches !== 'function' ||
      !chosen.matches(selector)
    ) {
      return false;
    }
    Array.prototype.forEach.call(
      group.querySelectorAll(selector),
      function(node) {
        setSelected(node, node === chosen);
      },
    );
    return true;
  }

  function bindExclusiveGroup(group, options) {
    options = options || {};
    var selector =
      options.selector || '.bb-visual-radio-btn, .bb-optcard';
    if (!group || typeof group.addEventListener !== 'function') return null;
    function handleClick(event) {
      var target = event.target;
      var chosen =
        target && typeof target.closest === 'function'
          ? target.closest(selector)
          : null;
      if (!chosen || chosen.disabled) return;
      if (!selectExclusive(group, chosen, selector)) return;
      if (typeof options.onSelect === 'function') {
        options.onSelect(chosen);
      }
    }
    group.addEventListener('click', handleClick);
    return function disconnect() {
      group.removeEventListener('click', handleClick);
    };
  }

  function group(definition, label) {
    return definition.groups.find(function(item) { return item.label === label; });
  }

  function lanyardCustomizationFor(handle, requestedValue) {
    var definition = get(handle);
    if (!definition) return '';
    var customizationGroup = group(definition, 'Customization');
    var options = customizationGroup ? customizationGroup.options : [];
    var requested = String(requestedValue || '').trim();
    if (requested === 'Solid Color' && !stockLanyardAvailable(handle)) return 'Customized';
    if (options.some(function(item) { return item.value === requested; })) {
      return requested;
    }
    return definition.standaloneCustomization || definition.defaultCustomization || 'Solid Color';
  }

  function syncLanyardColorQuantityState(input) {
    if (!input || typeof input.closest !== 'function') return false;
    var card = input.closest('.bb-lp-color');
    var hasQuantity = (parseInt(input.value, 10) || 0) > 0;
    if (card) card.classList.toggle('has-quantity', hasQuantity);
    return hasQuantity;
  }

  function quantityLabel(value) {
    return Number(value).toLocaleString('en-US');
  }

  function lanyardColorQuantityState(values, requestedStep, requestedCheckpoints) {
    var step = Number(requestedStep);
    if (!Number.isInteger(step) || step < 1) step = 50;

    var invalidIndexes = [];
    var total = 0;
    (values || []).forEach(function(value, index) {
      var quantity = Number(value);
      if (!Number.isInteger(quantity) || quantity < 0 || quantity % step !== 0) {
        invalidIndexes.push(index);
      }
      if (Number.isFinite(quantity) && quantity > 0) total += quantity;
    });

    var checkpoints = Array.from(new Set((requestedCheckpoints || [])
      .map(Number)
      .filter(function(value) { return Number.isInteger(value) && value > 0; })))
      .sort(function(left, right) { return left - right; });
    var previousCheckpoint = null;
    var nextCheckpoint = null;
    checkpoints.forEach(function(checkpoint) {
      if (checkpoint <= total) previousCheckpoint = checkpoint;
      if (nextCheckpoint === null && checkpoint >= total) nextCheckpoint = checkpoint;
    });

    var valid = invalidIndexes.length === 0 && checkpoints.indexOf(total) !== -1;
    var message = '';
    if (invalidIndexes.length) {
      message = 'Use ' + quantityLabel(step) + '-unit increments for every color.';
    } else if (!checkpoints.length) {
      message = 'Available quantity totals are loading.';
    } else if (total === 0 && nextCheckpoint !== null) {
      message = 'Add color quantities in packs of ' + quantityLabel(step) + '. The first available total is ' + quantityLabel(nextCheckpoint) + '.';
    } else if (!valid && previousCheckpoint !== null && nextCheckpoint !== null) {
      message = quantityLabel(total) + ' selected — remove ' + quantityLabel(total - previousCheckpoint) + ' for ' + quantityLabel(previousCheckpoint) + ', or add ' + quantityLabel(nextCheckpoint - total) + ' to reach ' + quantityLabel(nextCheckpoint) + '.';
    } else if (!valid && nextCheckpoint !== null) {
      message = quantityLabel(total) + ' selected — add ' + quantityLabel(nextCheckpoint - total) + ' to reach ' + quantityLabel(nextCheckpoint) + '.';
    } else if (!valid && previousCheckpoint !== null) {
      message = quantityLabel(total) + ' selected — remove ' + quantityLabel(total - previousCheckpoint) + ' to return to ' + quantityLabel(previousCheckpoint) + '.';
    }

    return {
      total: total,
      step: step,
      invalidIndexes: invalidIndexes,
      checkpoints: checkpoints,
      valid: valid,
      previousCheckpoint: previousCheckpoint,
      nextCheckpoint: nextCheckpoint,
      message: message,
    };
  }

  function syncLanyardQuantityControls(customInput, solidInput, customized, total) {
    var customWrap = customInput && customInput.closest('[data-bb-custom-quantity]');
    var solidWrap = solidInput && solidInput.closest('[data-bb-solid-quantity]');
    if (customWrap) customWrap.hidden = !customized;
    if (solidWrap) solidWrap.hidden = customized;
    if (customInput) {
      if (customized) customInput.setAttribute('data-bb-active-quantity', 'true');
      else customInput.removeAttribute('data-bb-active-quantity');
    }
    if (solidInput) {
      solidInput.value = String(Math.max(0, Number(total) || 0));
      solidInput.readOnly = true;
      solidInput.setAttribute('aria-readonly', 'true');
      if (customized) solidInput.removeAttribute('data-bb-active-quantity');
      else solidInput.setAttribute('data-bb-active-quantity', 'true');
    }
    return customized ? customInput : solidInput;
  }

  function syncLanyardColorPropertyState(inputs, customized) {
    Array.prototype.forEach.call(inputs || [], function(input) {
      var card = input.closest('.bb-lp-color');
      input.disabled = Boolean(customized) || Boolean(card && card.dataset.color === 'Custom');
    });
  }

  function stockLanyardAvailable(handle) {
    return handle === 'metal-clip-lanyard' || handle === 'bulldog-metal-clip-lanyards';
  }

  function syncBundleLanyardAvailability(root, handle, customization) {
    root.querySelectorAll('[data-bb-choice="lanyard-product"]').forEach(function(card) {
      setAvailability(card, customization === 'Solid Color' && !stockLanyardAvailable(card.dataset.bbValue)
        ? 'Solid Color is available with Bulldog Without Suspender hardware only. Choose Customized for this family.' : '');
    });
    root.querySelectorAll('[data-bb-choice="lanyard-mode"]').forEach(function(card) {
      setAvailability(card, card.dataset.bbValue === 'Solid Color' && !stockLanyardAvailable(handle)
        ? 'Choose the Bulldog Metal Clip family for Solid Color lanyards.' : '');
    });
  }

  function selectLanyardStockColor(root, chosenInput) {
    var inputs = Array.prototype.slice.call(root.querySelectorAll('.bb-lp-color__input'));
    var selected = chosenInput && Number(chosenInput.value) > 0 && !chosenInput.disabled
      ? chosenInput : inputs.find(function(input) { return !input.disabled && Number(input.value) > 0; });
    inputs.forEach(function(input) {
      if (input !== selected) input.value = '0';
      syncLanyardColorQuantityState(input);
    });
    var color = root.querySelector('[name="properties[Color]"]');
    if (!color) {
      color = root.ownerDocument.createElement('input');
      color.type = 'hidden';
      color.name = 'properties[Color]';
      root.appendChild(color);
    }
    color.value = selected ? selected.closest('.bb-lp-color').dataset.color : '';
    return color.value;
  }

  function syncLanyardAvailability(root, handle) {
    if (!root) return;
    var customization = root.querySelector('[data-bb-custom-input]');
    var stockAvailable = stockLanyardAvailable(handle);
    if (customization && customization.value === 'Solid Color' && !stockAvailable) customization.value = 'Customized';
    var solid = customization && customization.value === 'Solid Color';
    root.querySelectorAll('[data-bb-custom] .bb-lp-custom__opt').forEach(function(card) {
      setAvailability(card, card.dataset.value === 'Solid Color' && !stockAvailable
        ? 'Solid Color is available only for 3/8" Bulldog Without Suspender lanyards. Choose the Bulldog Metal Clip product.' : '');
      setSelected(card, customization && card.dataset.value === customization.value);
    });
    var stockAttachment = 'Iron Polished silver bulldog clip';
    var attachment = root.querySelector('[name="properties[Attachment type]"]');
    var widthInput = root.querySelector('[data-bb-width-input]');
    if (solid && attachment) attachment.value = stockAttachment;
    root.querySelectorAll('[data-bb-attachment-style] .bb-lp-card, select[name="properties[Attachment type]"] option').forEach(function(card) {
      var value = card.dataset.value || card.value;
      var reason = solid && value !== stockAttachment
        ? 'Solid Color is available with the Bulldog Without Suspender attachment only. Choose Customized for this attachment.' : '';
      if (!solid && card.tagName === 'OPTION' && widthInput && lanyardSupportedWidths(value).indexOf(widthInput.value) === -1) {
        reason = 'This attachment is not available at ' + widthInput.value + ' width.';
      }
      setAvailability(card, reason);
      if (card.tagName !== 'OPTION') setSelected(card, attachment && value === attachment.value);
    });
    var widthWrap = root.querySelector('[data-bb-width]');
    var supported = solid ? ['3/8"'] : lanyardSupportedWidths(attachment && attachment.value);
    if (widthWrap && supported.length) {
      var cards = Array.prototype.slice.call(widthWrap.querySelectorAll('.bb-lp-card'));
      cards.forEach(function(card) {
        card.hidden = false;
        setAvailability(card, supported.indexOf(card.dataset.value) === -1
          ? (solid ? 'Solid Color is available in 3/8" width only. Choose Customized for other widths.' : 'This width is not available with the selected attachment style.') : '');
      });
      var selected = cards.find(function(card) { return !card.disabled && widthInput && card.dataset.value === widthInput.value; }) || cards.find(function(card) { return !card.disabled; });
      if (selected) {
        selectExclusive(widthWrap, selected, '.bb-lp-card');
        if (widthInput) widthInput.value = selected.dataset.value;
      }
    }
    root.querySelectorAll('.bb-lp-color').forEach(function(card) {
      var unavailable = card.dataset.color === 'Custom';
      var reason = unavailable ? 'Choose one of the nine standard colors. Custom colors require Customized lanyards.' : '';
      card.classList.toggle('is-disabled', unavailable);
      if (reason) {
        card.setAttribute('title', reason);
        card.setAttribute('aria-disabled', 'true');
      }
      card.querySelectorAll('input, button').forEach(function(control) {
        setAvailability(control, reason);
        if (control.tagName === 'INPUT') {
          control.disabled = !solid || unavailable;
          if (unavailable) control.value = '0';
        }
      });
    });
    root.querySelectorAll('[name="properties[Print method]"]').forEach(function(input) { input.disabled = Boolean(solid); });
    if (solid) selectLanyardStockColor(root);
    var color = root.querySelector('[name="properties[Color]"]');
    if (color) color.disabled = !solid;
  }

  function hydrateLanyard(root, handle) {
    var definition = get(handle);
    if (!root || !definition || definition.purchasable === false) return;
    syncNodes(root.querySelector('.bb-lp-family__track'), '.bb-lp-family__option', lanyardFamilies, function(node, item) {
      var labels = node.querySelectorAll('span');
      var label = node.querySelector('.bb-lp-family__label') || labels[labels.length - 1];
      node.setAttribute('href', '/products/' + item.handle);
      node.dataset.bbLanyardFamily = item.handle;
      if (label) label.textContent = item.label;
      if (item.handle === handle) node.setAttribute('aria-current', 'page');
      else node.removeAttribute('aria-current');
    });

    var customization = group(definition, 'Customization').options;
    var selectedCustomization = definition.standaloneCustomization || definition.defaultCustomization || 'Solid Color';
    syncNodes(root.querySelector('[data-bb-custom]'), '.bb-lp-custom__opt', customization, function(node, item) {
      node.dataset.value = item.value;
      var name = node.querySelector('.bb-lp-custom__name');
      if (name) name.textContent = item.label;
      setSelected(node, item.value === selectedCustomization);
    });

    var colors = group(definition, 'Color').options;
    syncNodes(root.querySelector('[data-bb-colors]'), '.bb-lp-color', colors, function(node, item) {
      node.dataset.color = item.value;
      var circle = node.querySelector('.bb-lp-color__circle');
      var name = node.querySelector('.bb-lp-color__name');
      var input = node.querySelector('.bb-lp-color__input');
      if (circle) circle.style.background = item.hex || '#cccccc';
      if (name) name.textContent = item.label;
      if (input) input.name = 'properties[Color: ' + item.value + ']';
    });

    [['Attachment / Clips', '[data-bb-attach]'], ['Width', '[data-bb-width]']].forEach(function(entry) {
      var options = group(definition, entry[0]).options;
      syncNodes(root.querySelector(entry[1]), '.bb-lp-card', options, function(node, item, index) {
        node.dataset.value = item.value;
        var title = node.querySelector('.bb-lp-card__title');
        var sub = node.querySelector('.bb-lp-card__sub');
        if (title) title.textContent = item.label;
        if (sub) sub.textContent = item.meta || '';
        setSelected(node, entry[0] === 'Attachment / Clips' ? index === 1 : item.value === '1/2"');
      });
    });

    var family = lanyardFamilyFor(handle);
    if (family) {
      syncNodes(root.querySelector('[data-bb-attachment-style]'), '.bb-lp-style', family.styles, function(node, item, index) {
        node.dataset.value = item.value;
        var title = node.querySelector('.bb-lp-card__title');
        var sub = node.querySelector('.bb-lp-card__sub');
        if (title) title.textContent = item.label;
        if (sub) sub.textContent = item.meta || '';
        setSelected(node, index === 0);
      });
    }

    [['Print method', 'select[name="properties[Print method]"]'], ['Attachment type', 'select[name="properties[Attachment type]"]']].forEach(function(entry) {
      var select = root.querySelector(entry[1]);
      var options = group(definition, entry[0]).options;
      if (!select) return;
      select.innerHTML = options.map(function(item) {
        var supportedWidths = (item.supportedWidths || []).join('|');
        return '<option value="' + item.value.replace(/"/g, '&quot;') + '"' +
          (supportedWidths ? ' data-supported-widths="' + supportedWidths.replace(/"/g, '&quot;') + '"' : '') +
          '>' + item.label + (item.meta ? ' — ' + item.meta : '') + '</option>';
      }).join('');
    });
  }

  function hydrateAdhesive(root) {
    var definition = get('adhesive-name-badge');
    if (!root || !definition) return;
    syncNodes(root.querySelector('[data-bb-adh-sizes]'), '.bb-adh-size-card', group(definition, 'Size').options, function(node, item, index) {
      node.dataset.value = item.value;
      var name = node.querySelector('.bb-adh-size-card__name');
      var dims = node.querySelector('.bb-adh-size-card__dims');
      if (name) name.textContent = item.label;
      if (dims) dims.textContent = item.meta || '';
      setSelected(node, index === 0);
    });
    syncNodes(root.querySelector('[data-bb-adh-colors]'), '.bb-adh-color-btn', group(definition, 'Color').options, function(node, item, index) {
      node.dataset.value = item.value;
      var name = node.querySelector('.bb-adh-color-btn__name');
      if (name) name.textContent = item.label;
      setSelected(node, index === 0);
    });
    syncNodes(root.querySelector('.bb-adh-design'), 'label', group(definition, 'Design').options, function(node, item, index) {
      var input = node.querySelector('input');
      if (input) {
        input.value = item.value;
        input.checked = index === 0;
      }
      Array.prototype.slice.call(node.childNodes).forEach(function(child) {
        if (child.nodeType === 3) child.remove();
      });
      node.appendChild(document.createTextNode(' ' + item.label));
    });
  }

  function setAvailability(control, reason) {
    var disabled = Boolean(reason);
    control.disabled = disabled;
    var label = control.closest('label');
    [control, label].filter(Boolean).forEach(function(node) {
      node.classList.toggle('is-disabled', disabled);
      if (disabled) {
        node.setAttribute('aria-disabled', 'true');
        node.setAttribute('title', reason);
      } else {
        node.removeAttribute('aria-disabled');
        node.removeAttribute('title');
      }
    });
  }

  function syncAdhesiveAvailability(root) {
    if (!root) return false;
    var sizeInput = root.querySelector('[data-bb-adh-size-val]');
    var colorInput = root.querySelector('[data-bb-adh-color-val]');
    var colors = root.querySelector('[data-bb-adh-colors]');
    if (!sizeInput || !colorInput || !colors) return false;
    var clearOnly = true;
    var changed = clearOnly && normalize(colorInput.value) === 'white';
    if (changed) colorInput.value = 'Clear';
    Array.prototype.forEach.call(colors.querySelectorAll('.bb-adh-color-btn'), function(card) {
      var unavailable = clearOnly && normalize(card.dataset.value) === 'white';
      setAvailability(card, unavailable ? 'Adhesive badges are available in Clear only. White is not available.' : '');
      setSelected(card, !unavailable && card.dataset.value === colorInput.value);
    });
    return changed;
  }

  function blankBadgeUnavailableReason(root) {
    function value(label) {
      var input = root.querySelector('[name="properties[' + label + ']"]');
      return normalize(input && input.value);
    }
    var material = value('Material');
    var size = value('Size');
    var sides = root.querySelector('[data-bb-sides-input]');
    if (material === 'paper' && value('Perforated Slots') && value('Perforated Slots') !== 'none') {
      return 'Blank paper badges are available without perforated slots. Choose None.';
    }
    if (material === 'tear-resistant' && value('On-Site Printing') === 'yes-color' &&
      normalize(sides && sides.value) === 'single' && ['4x3', '4x6'].indexOf(size) !== -1) {
      return 'Blank color-printable tear-resistant badges are available Double-Sided only. Choose Double-Sided or pre-printed badges.';
    }
    if (material === 'plastic' && ['3.74x5.31', '4.33x6.3'].indexOf(size) !== -1) {
      return 'This plastic badge size is available pre-printed only. Choose a pre-printed design.';
    }
    return '';
  }

  function hydrateNameBadge(root, handle) {
    var definition = get(handle);
    if (!root || !definition) return;
    ['Finish'].forEach(function(label) {
      var definitionGroup = group(definition, label);
      if (!definitionGroup) return;
      var key = label.toLowerCase().replace(/\s+/g, '-');
      syncNodes(root.querySelector('[data-bb-visual-radios="' + key + '"]'), '.bb-visual-radio-btn', definitionGroup.options, function(node, item, index) {
        node.dataset.value = item.value;
        node.textContent = item.label;
        setSelected(node, index === 0);
      });
    });
    if (definition.forcedDesign) {
      Array.prototype.forEach.call(
        root.querySelectorAll('input[name="properties[Design]"]'),
        function(input) {
          var selected = input.value === definition.forcedDesign;
          input.checked = selected;
          input.disabled = !selected;
          var label = input.closest('label');
          if (label) label.hidden = !selected;
        },
      );
    }
  }

  function syncNameBadgeDesignAvailability(root) {
    if (!root) return false;
    var sidesInput = root.querySelector('[data-bb-sides-input]');
    var singleSided = String((sidesInput && sidesInput.value) || '')
      .trim()
      .toLowerCase() === 'single';
    var designInputs = Array.prototype.slice.call(
      root.querySelectorAll('input[name="properties[Design]"]'),
    );
    var oneSide = designInputs.find(function(input) {
      return String(input.value || '').trim().toLowerCase() ===
        'pre-printed on one side only';
    });
    var bothSides = designInputs.find(function(input) {
      return String(input.value || '').trim().toLowerCase() ===
        'pre-printed on both sides';
    });
    var changed = false;
    var material = root.querySelector('[name="properties[Material]"]');
    var size = root.querySelector('[name="properties[Size]"]');
    var blankOnly = normalize(material && material.value) === 'tear-resistant' && normalize(size && size.value) === '4x5';
    if (oneSide) setAvailability(oneSide, blankOnly ? '4" × 5" tear-resistant badges are available Blank only.' : '');
    if (singleSided && bothSides && bothSides.checked && oneSide) {
      bothSides.checked = false;
      oneSide.checked = true;
      changed = true;
    }
    if (bothSides) setAvailability(bothSides, blankOnly ? '4" × 5" tear-resistant badges are available Blank only.' : (singleSided ? 'Choose Double-Sided to use this option.' : ''));
    var blank = designInputs.find(function(input) { return normalize(input.value) === 'blank'; });
    if (blank) {
      setAvailability(blank, blankBadgeUnavailableReason(root));
      if (blankOnly && !blank.checked) {
        blank.checked = true;
        changed = true;
      }
      if (blank.disabled && blank.checked) {
        blank.checked = false;
        var replacement = designInputs.find(function(input) { return !input.disabled; });
        if (replacement) replacement.checked = true;
        changed = true;
      }
    }
    return changed;
  }

  function firstEnabledOption(items) {
    return (items || []).find(function(item) { return !item.disabled; }) || null;
  }

  function optionCardState(item, selectedValue) {
    var disabled = !!(item && item.disabled);
    var selected = !disabled && !!item && String(item.v) === String(selectedValue);
    return {
      disabled: disabled,
      selected: selected,
      ariaChecked: selected ? 'true' : 'false',
      ariaPressed: selected ? 'true' : 'false',
      ariaDisabled: disabled ? 'true' : 'false',
    };
  }

  function plasticClearPouchState(size, value) {
    var available = String(size || '') === '4.33x6.3';
    return {
      available: available,
      value: available && String(value || '') === 'Yes' ? 'Yes' : 'No',
    };
  }

  function titleCaseDisplay(value) {
    var text = String(value == null ? '' : value);
    return text.replace(/(^|[^A-Za-z0-9])([A-Za-z]+(?:'[A-Za-z]+)?)/g, function(match, prefix, word) {
      if (/^(?:cm|mm|in|ft|oz|lb|lbs|px)$/i.test(word)) return prefix + word;
      if (word.length > 1 && word === word.toUpperCase()) return prefix + word;
      return prefix + word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
  }

  return {
    get: get,
    groupsFor: groupsFor,
    nameBadgeMaterials: nameBadgeMaterials,
    lanyardFamilies: lanyardFamilies,
    lanyardFamilyFor: lanyardFamilyFor,
    lanyardSupportedWidths: lanyardSupportedWidths,
    lanyardCustomizationFor: lanyardCustomizationFor,
    syncLanyardColorQuantityState: syncLanyardColorQuantityState,
    lanyardColorQuantityState: lanyardColorQuantityState,
    syncLanyardQuantityControls: syncLanyardQuantityControls,
    syncLanyardColorPropertyState: syncLanyardColorPropertyState,
    syncLanyardAvailability: syncLanyardAvailability,
    syncBundleLanyardAvailability: syncBundleLanyardAvailability,
    selectLanyardStockColor: selectLanyardStockColor,
    selectExclusive: selectExclusive,
    bindExclusiveGroup: bindExclusiveGroup,
    hydrateNameBadge: hydrateNameBadge,
    syncNameBadgeDesignAvailability: syncNameBadgeDesignAvailability,
    hydrateLanyard: hydrateLanyard,
    hydrateAdhesive: hydrateAdhesive,
    syncAdhesiveAvailability: syncAdhesiveAvailability,
    firstEnabledOption: firstEnabledOption,
    optionCardState: optionCardState,
    plasticClearPouchState: plasticClearPouchState,
    titleCaseDisplay: titleCaseDisplay,
  };
});
